import React from 'react';

/**
 * KpiTile — tuile KPI compacte (valeur N + comparaison N-1).
 * Partagée entre la page Staff evolution et son impression.
 */
export default function KpiTile({ label, value, cmp, delta, sign, prevYear }) {
  return (
    <div style={tileStyle}>
      <div style={tileLabelStyle}>{label}</div>
      <div style={tileValueStyle}>{value}</div>
      <div style={tileSubStyle}>
        vs {prevYear} : <span style={tileMono}>{cmp}</span>
        {delta && (
          <span style={{ ...tileMono, marginLeft: 5, color: tileDeltaColor(sign), fontWeight: 500 }}>
            ({delta})
          </span>
        )}
      </div>
    </div>
  );
}

function tileDeltaColor(sign) {
  if (sign === 'positive') return '#5C7A3E';
  if (sign === 'negative') return '#BA5D4A';
  return '#6b6253';
}

/* La tuile est désormais la SEULE couche de card (la section INDICATEURS n'est
   plus une carte) : fond légèrement teinté posé sur le greige de page + filet
   et ombre douce pour la lever. */
const tileStyle = {
  background: '#FDFAF4',
  border: '0.5px solid var(--color-border)',
  borderRadius: 'var(--radius-card)',
  padding: '10px 12px',
  boxShadow: '0 1px 2px rgba(43, 32, 62, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};
const tileLabelStyle = { fontSize: 11, color: '#6b6253', fontWeight: 400 };
const tileValueStyle = {
  fontFamily: 'JetBrains Mono, monospace',
  fontVariantNumeric: 'tabular-nums',
  fontSize: 16,
  fontWeight: 500,
  color: '#2B203E',
  lineHeight: 1.15,
};
const tileSubStyle = { fontSize: 10.5, color: '#6b6253' };
const tileMono = { fontFamily: 'JetBrains Mono, monospace', fontVariantNumeric: 'tabular-nums' };
